<template>
    <div>
        <head-layout title="Webhooks" />

        <div class="text-h2">Webhooks</div>

        <v-data-table :items="hooks" :headers="headers"></v-data-table>
    </div>
</template>

<script>
import HeadLayout from "@/Layouts/HeadLayout";

export default {
    name: "Webhooks",

    components: { HeadLayout },

    data() {
        return {
            headers: [
                { text: "Name", value: "name" },
                { text: "Event", value: "event" },
                { text: "Target", value: "target_url" },
                { text: "Active", value: "active" },
            ],
        };
    },

    computed: {
        hooks() {
            return this.$page.props.webhooks.webhooks;
        },
    },
};
</script>

<style scoped></style>
